import type { AudioCachePort } from "../../ports/audio-cache.port";
import { createFilesystemBlobCache } from "./filesystem-blob-cache";

const store = createFilesystemBlobCache("audio", "audio/mpeg");

export const audioCacheCapacitorAdapter: AudioCachePort = {
	get: store.get,
	put: store.put,
	evict: store.evict,
	size: store.size,
	keys: store.keys,
	sizeBytes: store.sizeBytes,
	meta: store.meta,
};
